import Base from "formiojs/components/_classes/component/Component";
//import editForm from 'formiojs/components/table/Table.form'

export default class CheckMatrix extends Base {
  constructor(component, options, data) {
    super(component, options, data);
    this.foo = "bar";
    this.isBuilderMode = this.isBuilderMode.bind(this);
  }

  static schema() {
    return Base.schema({
      type: "checkmatrix",
      numRows: 1,
      numCols: 2,
    });
  }

  static builderInfo = {
    title: "Check Matrix",
    group: "basic",
    icon: "fa fa-table",
    weight: 70,
    documentation: "http://abc.com/userguide/#table",
    schema: CheckMatrix.schema(),
  };

  isBuilderMode() {
    const { element: pEl, id, root } = this.parent;
    console.log("preview", this.options.preview);
    console.log("builderMode", this.builderMode);
    if (this.builderMode) {
      return true;
    }

    if (id !== root.id) {
      return false;
    }

    return !pEl || pEl.getAttribute("ref") === "preview";
  }

  //static editForm = editForm

  /**
   * Render returns an html string of the fully rendered component.
   *
   * @param children - If this class is extendended, the sub string is passed as children.
   * @returns {string}
   */
  render(children) {
    // To make this dynamic, we could call this.renderTemplate('templatename', {}).
    console.log("render", "start");
    let tableClass = "table ";
    ["striped", "bordered", "hover", "condensed"].forEach((prop) => {
      if (this.component[prop]) {
        tableClass += `table-${prop} `;
      }
    });

    let content = "";

    for (let i = 0; i < this.component.numRows; i++) {
      let row = "<tr>";
      for (let j = 0; j < this.component.numCols; j++) {
        let cell = "<td>";

        cell += this.renderTemplate("input", {
          input: {
            type: "input",
            ref: `${this.component.key}-${i}`,
            attr: {
              id: `${this.component.key}-${i}-${j}`,
              class: "form-control",
              type: "checkbox",
            },
          },
        });
        if (i == 0 && j == 0) {
            cell += `<h6>BuilderMode-${this.builderMode},preview-${this.options.preview},modalEdit-${this.component.modalEdit}</h6>`;
        //   console.log("preview", this.options.preview);
        //   console.log("builderMode", this.builderMode);
        }
        if (this.isBuilderMode()) {
          cell += "<h6>BuilderModeFuncSet</h6>";
        }
        cell += "</td>";
        row += cell;
      }
      row += "</tr>";
      content += row;
    }
    console.log("render", "End");
    // Calling super.render will wrap it html as a component.
    return super.render(`
<table class=${tableClass}>
  <tbody>
     ${content}
  </tbody>
</table>
    `);
  }

  /**
   * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
   * elements to attach functionality to.
   *
   * @param element
   * @returns {Promise}
   */
  attach(element) {
    console.log("Attach called for element", element);
    const refs = {};

    for (let i = 0; i < this.component.numRows; i++) {
      refs[`${this.component.key}-${i}`] = "multiple";
    }

    this.loadRefs(element, refs);

    this.checks = [];
    for (let i = 0; i < this.component.numRows; i++) {
      this.checks[i] = Array.prototype.slice.call(
        this.refs[`${this.component.key}-${i}`],
        0
      );

      // Attach click events to each input in the row
      this.checks[i].forEach((input) => {
        this.addEventListener(input, "click", () => this.updateValue());
      });
    }

    // Allow basic component functionality to attach like field logic and tooltips.
    return super.attach(element);
  }

  /**
   * Get the value of the component from the dom elements.
   *
   * @returns {Array}
   */
  getValue() {
    console.log(`getValue - called`);

    var data = { value: [] };
    for (var rowIndex in this.checks) {
      var row = this.checks[rowIndex];
      data.value[rowIndex] = [];
      for (var colIndex in row) {
        var col = row[colIndex];
        data.value[rowIndex][colIndex] = !!col.checked;
      }
    }
    return data;
  }

  /**
   * Set the value of the component into the dom elements.
   *
   * @param value
   * @returns {boolean}
   */
  setValue(data) {
    console.log(`set value -`, data);
    if (!data || !data.value) {
      return;
    }
    for (var rowIndex in this.checks) {
      var row = this.checks[rowIndex];
      if (!data.value[rowIndex]) {
        break;
      }
      for (var colIndex in row) {
        var col = row[colIndex];
        if (!data.value[rowIndex][colIndex]) {
          return false;
        }
        let checked = data.value[rowIndex][colIndex] ? 1 : 0;
        col.value = checked;
        col.checked = checked;
      }
    }
  }
}
